module.exports = __webpack_public_path__ + "img/joinVip.3ad1b321.png";